export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3" style={{ fontFamily: "var(--font-heading)" }}>
          最新动态
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">平台最新上线内容与功能更新，精彩不错过</p>

        <div className="max-w-3xl mx-auto">
          {/* Update 1 */}
          <div className="relative pl-8 pb-8 border-l-2 border-primary-200 last:border-transparent last:pb-0">
            <div className="absolute left-0 top-0 -translate-x-1/2 w-4 h-4 rounded-full bg-primary-500 border-2 border-background-100"></div>
            <div className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/60">
              <div className="flex items-center gap-2 mb-1">
                <span className="text-xs font-medium text-primary-500 bg-primary-100 px-2 py-0.5 rounded-full whitespace-nowrap">新片上线</span>
                <span className="text-xs text-foreground-400">2026.07.30</span>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">暑期档重磅新片《星际迷航：新纪元》高清上线</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">好莱坞科幻巨制今日登陆桃子视频，4K超清画质，中英双语字幕可选，影迷们速来围观。</p>
            </div>
          </div>

          {/* Update 2 */}
          <div className="relative pl-8 pb-8 border-l-2 border-accent-200 last:border-transparent last:pb-0">
            <div className="absolute left-0 top-0 -translate-x-1/2 w-4 h-4 rounded-full bg-accent-500 border-2 border-background-100"></div>
            <div className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/60">
              <div className="flex items-center gap-2 mb-1">
                <span className="text-xs font-medium text-accent-500 bg-accent-100 px-2 py-0.5 rounded-full whitespace-nowrap">剧集更新</span>
                <span className="text-xs text-foreground-400">2026.07.29</span>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">《暗夜追踪者》第三季第8集更新，剧情迎来大反转</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">本周剧情揭露凶手真实身份，社交媒体讨论热度飙升，登顶热搜话题榜首。</p>
            </div>
          </div>

          {/* Update 3 */}
          <div className="relative pl-8 pb-8 border-l-2 border-secondary-200 last:border-transparent last:pb-0">
            <div className="absolute left-0 top-0 -translate-x-1/2 w-4 h-4 rounded-full bg-secondary-500 border-2 border-background-100"></div>
            <div className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/60">
              <div className="flex items-center gap-2 mb-1">
                <span className="text-xs font-medium text-secondary-500 bg-secondary-100 px-2 py-0.5 rounded-full whitespace-nowrap">综艺上线</span>
                <span className="text-xs text-foreground-400">2026.07.28</span>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">《欢乐挑战赛》第七季首播，全新嘉宾阵容引期待</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">本季加入多位人气明星，首期节目笑料不断，弹幕互动量已突破百万。</p>
            </div>
          </div>

          {/* Update 4 */}
          <div className="relative pl-8 pb-8 border-l-2 border-primary-200 last:border-transparent last:pb-0">
            <div className="absolute left-0 top-0 -translate-x-1/2 w-4 h-4 rounded-full bg-primary-500 border-2 border-background-100"></div>
            <div className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/60">
              <div className="flex items-center gap-2 mb-1">
                <span className="text-xs font-medium text-primary-500 bg-primary-100 px-2 py-0.5 rounded-full whitespace-nowrap">专题上线</span>
                <span className="text-xs text-foreground-400">2026.07.27</span>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">"国产悬疑天花板"专题上线，收录15部口碑神作</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">从《白夜追凶》到《隐秘的角落》，精选国产悬疑剧巅峰之作，一口气追完不费劲。</p>
            </div>
          </div>

          {/* Update 5 */}
          <div className="relative pl-8 pb-8 border-l-2 border-accent-200 last:border-transparent last:pb-0">
            <div className="absolute left-0 top-0 -translate-x-1/2 w-4 h-4 rounded-full bg-accent-500 border-2 border-background-100"></div>
            <div className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/60">
              <div className="flex items-center gap-2 mb-1">
                <span className="text-xs font-medium text-accent-500 bg-accent-100 px-2 py-0.5 rounded-full whitespace-nowrap">动漫更新</span>
                <span className="text-xs text-foreground-400">2026.07.26</span>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">七月新番《星灵奇旅》同步上线，首周播放量破纪录</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">改编自人气漫画的奇幻冒险动画，精良制作引发二次元圈热议，蓝莓视频同步更新。</p>
            </div>
          </div>

          {/* Update 6 */}
          <div className="relative pl-8 pb-8 border-l-2 border-secondary-200 last:border-transparent last:pb-0">
            <div className="absolute left-0 top-0 -translate-x-1/2 w-4 h-4 rounded-full bg-secondary-500 border-2 border-background-100"></div>
            <div className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/60">
              <div className="flex items-center gap-2 mb-1">
                <span className="text-xs font-medium text-secondary-500 bg-secondary-100 px-2 py-0.5 rounded-full whitespace-nowrap">纪录片</span>
                <span className="text-xs text-foreground-400">2026.07.25</span>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">BBC《地球脉动》第三季高清全集上线，自然奇观震撼人心</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">豆瓣9.8分神级纪录片全8集一次性上线，4K画质展现地球最壮丽的自然景观。</p>
            </div>
          </div>

          {/* Update 7 */}
          <div className="relative pl-8 pb-0 border-l-2 border-transparent">
            <div className="absolute left-0 top-0 -translate-x-1/2 w-4 h-4 rounded-full bg-primary-500 border-2 border-background-100"></div>
            <div className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/60">
              <div className="flex items-center gap-2 mb-1">
                <span className="text-xs font-medium text-primary-500 bg-primary-100 px-2 py-0.5 rounded-full whitespace-nowrap">平台升级</span>
                <span className="text-xs text-foreground-400">2026.07.24</span>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">播放器全面升级，支持倍速播放和记忆续播功能</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">新增0.5x-2x倍速播放、自动跳过片头片尾、断点续播等功能，观影体验全面优化。</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}